import Cookies from 'js-cookie';
import { getStoredDarkMode, persistDarkMode } from '@/utils/theme';

const state = {
    sidebar: {
        opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
        withoutAnimation: false
    },
    darkMode: getStoredDarkMode(),
    device: 'desktop',
    rootRouter: sessionStorage.rootRouter ? sessionStorage.rootRouter : 'appManage',
    RouterPath: '',
    RouterData: {}
};

const mutations = {
    TOGGLE_SIDEBAR: state => {
        state.sidebar.opened = !state.sidebar.opened;
        state.sidebar.withoutAnimation = false;
        if (state.sidebar.opened) {
            Cookies.set('sidebarStatus', 1);
        } else {
            Cookies.set('sidebarStatus', 0);
        }
    },
    SET_SIDEBAR: (state, status) => {
        state.sidebar.opened = status;
        state.sidebar.withoutAnimation = false;
        if (state.sidebar.opened) {
            Cookies.set('sidebarStatus', 1);
        } else {
            Cookies.set('sidebarStatus', 0);
        }
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
        Cookies.set('sidebarStatus', 0);
        state.sidebar.opened = false;
        state.sidebar.withoutAnimation = withoutAnimation;
    },
    TOGGLE_DEVICE: (state, device) => {
        state.device = device;
    },
    CHANGE_ROOTROUTER: (state, newRouter) => {
        state.rootRouter = newRouter;
    },
    CHANGE_ROUTERPATH: (state, newRouterpATH) => {
        state.RouterPath = newRouterpATH;
    },
    CHANGE_ROUTER: (state, routerData) => {
      state.RouterData = routerData;
    },
    SET_DARK_MODE: (state, value) => {
        state.darkMode = !!value;
    }
};

const actions = {
    toggleSideBar({commit}) {
        commit('TOGGLE_SIDEBAR');
    },
    setSidebar({commit}, status) {
        commit('SET_SIDEBAR', status);
    },
    closeSideBar({commit}, {withoutAnimation}) {
        commit('CLOSE_SIDEBAR', withoutAnimation);
    },
    toggleDevice({commit}, device) {
        commit('TOGGLE_DEVICE', device);
    },
    changeRootRouter({commit}, newRouter) {
        commit('CHANGE_ROOTROUTER', newRouter);
    },
    changeRouterPath({commit}, newRouterPath) {
      commit('CHANGE_ROUTERPATH', newRouterPath);
    },
    changeRouter({commit}, routerData) {
      commit('CHANGE_ROUTER', routerData);
    },
    setDarkMode({ commit }, value) {
        const on = !!value;
        commit('SET_DARK_MODE', on);
        persistDarkMode(on);
    },
    toggleDarkMode({ commit, state }) {
        const on = !state.darkMode;
        commit('SET_DARK_MODE', on);
        persistDarkMode(on);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
